export default "__VITE_ASSET__CdsqYh$G__"